import { useEffect, useState } from "react";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
// import { useRouter } from "next/router";

// import routes from "routes";

import WelcomeStep from "./steps/WelcomeStep";
import CommunityStep from "./steps/CommunityStep";
// import MonetiseAudienceStep from "./steps/MonetiseAudienceStep";
import AuthenticationStep from "./steps/AuthenticationStep";

import {
  validateUserCountry,
  validateUserFullname,
} from "./steps/WelcomeStep/validators";
import {
  validateUserCategory,
  validateUserCommunity,
  validateUserSocialLink,
} from "./steps/CommunityStep/validators";
import { validateUserContentMode } from "./steps/MonetiseAudienceStep/validators";
import { validatePhoneNumber } from "./steps/AuthenticationStep/validators";
import httpf_noauth from "utils/api/frontend/httpf_noauth";

const steps = [
  WelcomeStep,
  CommunityStep,
  // MonetiseAudienceStep,
  AuthenticationStep,
];

const welcomeStepValidators = [validateUserFullname, validateUserCountry];
const communityStepValidators = [
  validateUserSocialLink,
  validateUserCommunity,
  validateUserCategory,
];
// const monetiseAudienceStepValidators = [validateUserContentMode];
const authenticationStepValidators = [validatePhoneNumber];

const validators = [
  welcomeStepValidators,
  communityStepValidators,
  // monetiseAudienceStepValidators,
  authenticationStepValidators,
];

export default function OnboardingForm({ initialFormData }) {
  const [activeStep, setActiveStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(getIntialData());
  const [formErrors, setFormErrors] = useState({});
  const [categories, setCategories] = useState({});
  const [contentModes, setContentModes] = useState([]);
  const [communitySize, setCommunitySize] = useState([]);
  // const router = useRouter();

  const formOptions = {
    categories,
    contentModes,
    communitySize,
  };

  function getIntialData() {
    // Hard coded/from api also
    let initialData;

    if (initialFormData) {
      initialData = initialFormData;
    } else {
      initialData = {};
    }

    return initialData;
  }

  function onFieldChange(e, { formatValue, validator, required }) {
    const name = e.target.name;
    let value = e.target.value;
    // console.log(name, value);
    // Clear previous errors
    setFormErrors({ ...formErrors, [name]: "" });
    // Format value if formatter exists
    if (formatValue) {
      value = formatValue(value);
      // console.log(name, value);
    }

    const newFormData = {
      ...formData,
      [name]: value,
    };

    setFormData(newFormData);

    if (validator) {
      const error = validator(newFormData);
      if (error) {
        setFormErrors({ ...formErrors, ...error });
      }
      return null;
    }
    // Add required error if required
    if (required) {
      if (!value) {
        setFormErrors({ ...formErrors, [name]: "Required" });
        return null;
      }
    }
  }

  // function redirectCallback() {
  //   router.replace(routes.home.route);
  // }

  async function saveFormData() {
    const hasErrors = validateEverything();
    if (!hasErrors) {
      //   await createChannelApi(
      //     formData,
      //     formErrors,
      //     setFormErrors,
      //     setIsLoading,
      //     redirectCallback
      //   );
    }
  }

  function goPrev() {
    if (activeStep <= 0) return null;

    setActiveStep((prev) => prev - 1);
  }

  function goNext() {
    if (activeStep > steps.length - 1) return null;

    if (activeStep === steps.length - 1) {
      saveFormData();
    } else {
      setIsLoading(true);
      const hasErrors = validateEverything();

      if (!hasErrors) setActiveStep((next) => next + 1);
      setIsLoading(false);
    }
  }

  function validateEverything() {
    let formError = {};
    let hasErrors = false;
    validators[activeStep].forEach((validator) => {
      const error = validator(formData);
      if (error) {
        formError = { ...formError, ...error };
        hasErrors = true;
      }
    });

    console.log("formError", formError);
    setFormErrors({ ...formErrors, ...formError });
    return hasErrors;
  }

  useEffect(() => {
    httpf_noauth
      .get(`${QOOHOO_WEBSITE_DOMAIN}/api/get-categories`, {
        params: {
          type: "creator",
        }
      })
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    httpf_noauth
      .get(`${QOOHOO_WEBSITE_DOMAIN}/api/get-earlyform`)
      .then((res) => {
        const content_modes = [];
        Object.keys(res.data.content_modes).forEach((key, index) =>
          content_modes.push({
            value: key,
            label: res.data.content_modes[key],
          })
        );
        setContentModes(content_modes);
        const community_size = [];
        Object.keys(res.data.community_size).forEach((key, index) =>
          community_size.push({
            value: key,
            label: res.data.community_size[key],
          })
        );
        setCommunitySize(community_size);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const _ActiveStep = steps[activeStep];

  return (
    <_ActiveStep
      key={activeStep}
      formData={formData}
      formErrors={formErrors}
      onFieldChange={onFieldChange}
      formOptions={formOptions}
      step={activeStep}
      goPrev={goPrev}
      goNext={goNext}
      isLoading={isLoading}
    />
  );
}
